import { toAbsoluteUrl } from '../../../helpers'
import './styles.css'
import { Spin } from 'antd'
export function FallbackView() {

  return (
    <div className='loading-screen'>
      <span>Loading ...</span>
    </div>
  )
}
